export default {
  close: 'Schließen',
  cancel: 'Abbrechen',
  save: 'Speichern',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  submit: 'Absenden',
  reset: 'Zurücksetzen',
  download: 'Herunterladen',
  dataIterator: {
    pageText: '{0}-{1} von {2}',
    noResultsText: 'Kein passenden Eintrag gefunden',
    loadingText: 'Lade Einträge...',
  },
  dataTable: {
    itemsPerPageText: 'Einträge pro Seite:',
    ariaLabel: {
      sortDescending: ': Absteigend sortiert. Aktivieren Sie diese Option, um die Sortierung zu entfernen.',
      sortAscending: ': Aufsteigend sortiert. Aktivieren Sie diese Option, um absteigend zu sortieren.',
      sortNone: ': Nicht sortiert. Aktivieren Sie diese Option, um aufsteigend zu sortieren.',
    },
    sortBy: 'Sortiert nach',
  },
  dataFooter: {
    pageText: '{0}-{1} von {2}',
    itemsPerPageText: 'Einträge pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
  },
  datePicker: {
    itemsSelected: '{0} ausgewählt',
  },
  noDataText: 'Keine Daten verfügbar',
  carousel: {
    prev: 'Vorheriges Bild',
    next: 'Nächstes Bild',
  },
  calendar: {
    moreEvents: '{0} mehr',
  },
  sidebar: {
    dashboard: 'Dashboard',
    overview: 'Übersicht',
    general: 'Generell',
    features: 'Erweiterungen',
    views: 'Ansichten',
    settings: 'Einstellungen',
    management: {
      title: 'Verwaltung',
      users: 'Benutzer',
      groups: 'Gruppen',
    },
    form: {
      title: 'Formular',
      configure: 'Einstellungen',
      list: 'Liste',
      sum: 'Zusammengefasst',
    },
    support: 'Support',
    preferences: 'Einstellungen',
    feedback: 'Feedback senden',
    help: 'Hilfe',
  },
  form: {
    name: 'Formular',
    configure: {
      title: 'Form Einstellungen',
      buttonName: 'Button-Name',
      inputName: 'Input-Name',
      buttons: 'Button Felder',
      inputs: 'Input Felder',
    },
    sum: {
      inputField: 'Eingabefeld',
      buttonName: 'Button Name',
      value: 'Wert',
      selectForm: 'Formular auswählen',
    },
    addNew: 'Neu hinzufügen',
  },
  identifier: 'Kennung',
  name: 'Name',
  unit: 'Einheit',
  factor: 'Faktor',
  tag: 'Tag',
  actions: 'Aktionen',
  search: 'Suche',
  newItem: 'Neues Element',
  editItem: 'Element bearbeiten',
  article: 'Artikel',
  initial: 'Initial',
  current: 'Momentan',
  percent: 'Prozent',
  on: 'Ein',
  off: 'Aus',
  last: 'Letzten',
  day: 'Tag',
  week: 'Woche',
  month: 'Monat',
  year: 'Jahr',
  daily: 'Täglich',
  weekly: 'Wöchentlich',
  monthly: 'Monatlich',
  all: 'Alle',
  default: 'Standard',
  time: 'Zeit',
  generalInformation: 'Generelle Informationen',
  color: 'Farbe',
  text: 'Text',
  user: 'Benutzer',
  username: 'Benutzername',
  password: 'Passwort',
  groups: 'Gruppen',
  group: 'Gruppe',
  permissions: 'Berechtigungen',
  preferences: 'Einstellungen',
  selectLanguage: 'Sprache auswählen',
  darkTheme: 'Dunkles design',
  english: 'Englisch',
  german: 'Deutsch',
  projectTitle: 'Count-It',
  generalErrorMessage: 'Ein Fehler ist aufgetreten',
  savedSuccessfully: '{0} wurde erfolgreich gespeichert',
  deletedSuccessfully: '{0} wurde erfolgreich gelöscht',
  generalDeleteMessage: 'Möchten Sie dieses Element wirklich löschen?',
  email: 'E-Mail',
  emailReports: 'E-Mail Berichte',
  selectInterval: 'Interval auswählen',
  rules: {
    minLength: 'Die Mindestlänge ist {0} Zeichen.',
  },
};
